import { WebShareApiSettings } from './types/web-share-api-settings';

// Adds the mobile share tracking parameter to a URL, leaving it unchanged if it can't be parsed
const addMobileShareTracking = (url: string) => {
  try {
    const trackedUrl = new URL(url, window.location.href);
    trackedUrl.searchParams.set('ea.tracking.id', 'MobShare');
    return trackedUrl.href;
  } catch {
    return url;
  }
};

const canUseWebShareApi = (shareSettings: WebShareApiSettings) =>
  typeof navigator !== 'undefined' &&
  typeof navigator.share === 'function' &&
  navigator.canShare?.(shareSettings);

const handleWebShare = (shareSettings: WebShareApiSettings) => {
  try {
    navigator.share(shareSettings);
  } catch (error) {
    console.error('Error sharing:', error);
  }
};

const getWebShareSettings = (): WebShareApiSettings => {
  const textElement = document.querySelector('.alz-share-mobile-text');
  const titleElement = document.querySelector('.alz-share-mobile-title');
  const urlElement = document.querySelector('.alz-share-mobile-url');

  const currentPageUrl = new URL(window.location.href);
  // Replace page number after final slash with 1
  const actionUrlPage1 = currentPageUrl.href.replace(/\/([^/]*)$/, '/1');

  return {
    text: textElement?.textContent?.replace(/\n/g, '').trim() || '',
    title: titleElement?.textContent?.replace(/\n/g, '').trim() || '',
    url: addMobileShareTracking(
      urlElement?.textContent?.replace(/\n/g, '').trim() || actionUrlPage1,
    ),
  };
};

const isDeviceThatUsesApps = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const mobileShareButton = () => {
  const shareButtonsContainer = document.querySelector('.en__socialShares');
  if (!shareButtonsContainer) return;

  const webShareSettings = getWebShareSettings();

  const useMobileShareButton = isDeviceThatUsesApps && canUseWebShareApi(webShareSettings);

  if (!useMobileShareButton) {
    // Make sure built-in EN share buttons are visible if we're not using the mobile share button (e.g. on desktop)
    const enShareButtons = document.querySelectorAll('.en__socialShare');
    enShareButtons.forEach((button) => ((button as HTMLElement).style.display = 'block'));

    return;
  }

  shareButtonsContainer.classList.add('alz-share-mobile-show');

  shareButtonsContainer.insertAdjacentHTML(
    'beforeend',
    `<button aria-label='Share this page' class='alz-share-mobile-button' title='Share this page' type='button'>Share</button>`,
  );

  const mobileShareButton = shareButtonsContainer.querySelector('.alz-share-mobile-button');
  mobileShareButton?.addEventListener('click', () => handleWebShare(webShareSettings));
};
